import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

import {DashboardResolver} from './dashboardResolver';
import {PublicDashboardResolver} from './publicDashboardResolver';
import {RxAuthService} from '../services/rx-auth/rx-auth.service';

@Injectable({ providedIn: 'root' })
export class ProfileResolver implements Resolve<any> {
  constructor(
    private auth: RxAuthService,
    private dashboardResolver: DashboardResolver,
    private publicDashboardResolver: PublicDashboardResolver
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const authToken = localStorage.getItem('jwt_access');
    return authToken
      ? this.dashboardResolver.resolve(route, state)
      : this.publicDashboardResolver.resolve(route, state);
  }
}
